//Styles
import WindowOptions from "../base--app-container/window-options/WindowOptions";
import SearchBox from "../search_box/SearchBox";
import Styles from "./BaseNativeAppBar.module.scss";

interface BaseNativeAppBarProps {
  title: string;
  onClickCLoseWindow: () => void;
}

const BaseNativeAppBar = ({ title, onClickCLoseWindow }: BaseNativeAppBarProps) => {
  return (
    <div className={Styles.container}>
      <WindowOptions onClickCLoseWindow={onClickCLoseWindow} />
          <div className={Styles.title}>
      {
        title? 
            <>{title}</>
          : <div className={Styles.searchBox}><SearchBox placeholder={"https://priyanshdatyal-me.web.app"}/></div>
      }
      </div>
    </div>
  )
}

export default BaseNativeAppBar
